import { useEffect, useRef } from 'react';

export default function About() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          sectionRef.current?.querySelectorAll('.fade-item').forEach((el, i) => {
            setTimeout(() => {
              (el as HTMLElement).classList.add('opacity-100', 'translate-y-0');
              (el as HTMLElement).classList.remove('opacity-0', 'translate-y-6');
            }, i * 120);
          });
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-28 bg-white" ref={sectionRef}>
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <p className="fade-item opacity-0 translate-y-6 transition-all duration-700 text-[#2E5540] text-xs tracking-[0.3em] mb-4 uppercase">
          / About
        </p>
        <h2 className="fade-item opacity-0 translate-y-6 transition-all duration-700 text-4xl md:text-5xl font-bold text-[#1C2B22] tracking-tight mb-6">
          プロフィール
        </h2>
        <div className="w-12 h-px bg-[#2E5540] mb-10 mx-auto" />

        <div className="space-y-6 text-left">
          <p className="fade-item opacity-0 translate-y-6 transition-all duration-700 text-[#444] text-base leading-relaxed">
            大阪・西梅田を拠点に、中小企業・個人事業主向けのWEBサイト制作・SNS運用代行・デジタルマーケティングを専門とするクリエイターとして活動しています。
          </p>
          <p className="fade-item opacity-0 translate-y-6 transition-all duration-700 text-[#444] text-base leading-relaxed">
            「見た目の美しさだけでなく、成果につながるWEBを作る」という信念のもと、
            集客・問い合わせ増加・売上向上を目標に据えた制作・運用を提供しています。
          </p>
          <p className="fade-item opacity-0 translate-y-6 transition-all duration-700 text-[#444] text-base leading-relaxed">
            <span translate="no">GRAINN</span>設立後は、関西・全国のクライアントとの長期パートナーシップを大切にしながら、
            デジタル領域でのビジネス成長を伴走支援し続けています。
          </p>
        </div>

        <div className="fade-item opacity-0 translate-y-6 transition-all duration-700 mt-10 text-right">
          <p className="text-xs text-[#2E5540] tracking-widest mb-1 uppercase"><span translate="no">GRAINN</span> 代表</p>
          <p className="text-xl font-bold text-[#1C2B22] tracking-wide">後藤 慎吾</p>
        </div>

        <div className="fade-item opacity-0 translate-y-6 transition-all duration-700 mt-10 flex flex-wrap justify-center gap-4">
          {['WEBサイト制作', 'SNS運用代行', 'SEO対策', 'デジタルマーケティング', 'MEO対策'].map((tag) => (
            <span
              key={tag}
              className="px-5 py-2 rounded-full border border-[#2E5540]/30 text-[#2E5540] text-sm tracking-wide"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
